<template>
  <div>
    <b-row>
      <b-col cols="12" v-if="rate && criteria && criteria.length">
        <b-tabs nav-wrapper-class="e-tabs__header" class="e-tabs witch-icon" nav-class="e-tabs__nav-tabs" content-class="e-tabs__nav-item" :no-fade="true" @input="onChangeTab">
      
          <b-tab v-for="(criterion, i) in criteria" :title="criterion.criterion.title" :key="i" ref="tabs">
       
            <b-row class="e-view-rate">
              <b-col cols="9">
                <div class="eval" style="cursor: auto">
                  {{ criterion.evaluate.toFixed(1) }}
                </div>
                <div class="text">  
                  {{ criterion.justification }}
                </div>
              </b-col>
              <b-col cols="3">
                <em-asset-average-score :score="rate.averageRate.toFixed(1)">Rater total score</em-asset-average-score>
                <div class="rate-moderate" @click="state = 'moderating'" v-if="oneOf(state, ['complete', 'moderating'])">
                  <span>You score <i class="fas fa-pen"></i></span>
                  <span>
                    <star-rating class="stars" :read-only="true" v-model="eval" :padding="10" :inline="true" :show-rating="false" :increment="0.5" :star-size="15" inactive-color="#ffffff" active-color="#1875f0" :rounded-corners="true" border-color="#1875f0" :border-width="2"></star-rating>
                  </span>
                </div>
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
        <transition mode="in-out" name="fade">
          <div class="e-moderation-rate" v-if="state === 'moderating'">
            <star-rating class="stars" v-model="eval" :padding="10" :inline="true" :show-rating="false" :increment="0.5" :star-size="100" inactive-color="#ffffff" active-color="#1875f0" :rounded-corners="true" border-color="#1875f0" :border-width="4"></star-rating>
          </div>
        </transition>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import Vue from 'vue';
  import {mapGetters, mapActions} from 'vuex';
  import {oneOf} from "../../../utils/assest";

  export default {
		name: "e-moderation-view",
    props: {
      moderationId: {
        type: String,
      },
    },
    data() {
		  return {
        eval$: 0,
		    rate: null,
		    moderation: null,
        criteria: null,
        showedCriteria: {},
        state$: 'view'
      }
    },
    watch: {
		  moderationId: {
		    async handler(id) {
		      if(!id) return;

          this.rate = null;
          this.moderation = null;
          this.criteria = null;
          this.showedCriteria = {};

          await this.fetchModerationItem(id);
          this.moderation = this.getModeration(id);
          console.log('mim', this.moderation)

          this.eval = (this.moderation.evaluate || 0) / 2;
          this.state = this.eval > 0 ? 'complete' : 'view';

          await this.fetchRate(this.moderation.rate);
          this.rate = this.getRate(this.moderation.rate);
          console.log('mi2m', this.rate)

          await this.fetchCriteria(this.rate.criteria.map(c => c.criterion));
          this.criteria = this.rate.criteria.map(c => {
            return {
              evaluate: c.evaluate,
              justification: c.justification,
              criterion: this.getCriterion(c.criterion)
            }
          });
        },
        immediate: true,
      }
    },
    methods: {
      ...mapActions('moderation', {
        fetchModerationItem: 'fetchModerationItem',
      }),
      ...mapActions('rate', {
        fetchRate: 'fetchRate',
      }),
      ...mapActions('assets', {
        fetchCriteria: 'fetchCriteria',
      }),
      oneOf(value, data) {
        return oneOf(value, data);
      },
      onChangeTab(index) {
        if(!this.criteria || !this.criteria.length || !this.$refs.tabs || !this.$refs.tabs[index]) {
          return;
        }

        if(index !== undefined && index !== null) {
          // This is hack
          let silent = Vue.silent;
          Vue.silent = false;
          this.$refs.tabs[index].titleItemClass = 'is-showed';
          this.showedCriteria[index] = true;
          Vue.silent = silent;

          if(this.allCriteriaShowed()) {
            this.state = this.eval > 0 ? 'complete' : 'ready';
          }
        }
      },
      allCriteriaShowed() {
        if(!this.criteria || !this.criteria.length) {
          return false;
        }

        return Object.keys(this.showedCriteria).length === this.criteria.length  && _.every(this.showedCriteria, s => s === true);
      },
    },
    computed: {
      ...mapGetters('rate', {
        getRate: 'rate',
        criterionEval: 'getCriterionEvaluation',
        criterionJustification: 'getCriterionJustification',
        averageEvaluation: 'getAverageEvaluation',
      }),
      ...mapGetters('moderation', {
        getModeration: 'moderation',
      }),
      ...mapGetters('assets', {
        getCriterion: 'criterion'
      }),
      eval: {
        get() {
          return this.eval$ || 0;
        },
        set(val) {
          this.eval$ = val;
          this.$emit('changeEval', val);
          this.$store.commit('moderation/updateModerationEval', {id: this.moderationId, evaluate: val});
        }
      },
      state: {
        get() {
          return this.state$;
        },
        set(state){
          this.state$ = state;
          this.$emit('changeState', state);
        }
      },
      classesForCriteria() {
        return (index) => {
          let showed = this.showedCriteria[index] && this.showedCriteria[index] === true;
          // console.log(showed);
          return {
            [`is-showed`]: showed,
          }
        }
      }
      // criteriaEval(id) {
      //   return () => {
      //     this.rate.criteria.
      //   }
      // }
    }
	}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/elements/moderationView/view.vue